import * as React from "react"
import { useEffect } from "react"
import { disabledAfter } from "@ui-seeker/core"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import { COMMON_FILTER_KEYS, STOCK_ROUTES, YESTERDAY_DATE } from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { useStockChangesRoleConfig } from "./@hooks"


export default function StockChangesFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(STOCK_ROUTES.STOCK_CHANGES_ID, STOCK_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	const { isMarketplacesUser } = useStockChangesRoleConfig()

    return <Box data-tour="changes-filters">
    <CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true,
			currentPrevDates: true, seller: isMarketplacesUser,
		}}
		compProps={{
			country: { disableClearable: true },
			sku: { grid: { md: isMarketplacesUser ? 4 : 6 } },
			favFiltersOnlyLine: { grid: { md: 10 } },
			favFilters: {
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
				],
				dashboardKey: STOCK_ROUTES.STOCK_CHANGES_ID
			},
			currentPrevDates: {  shouldDisableDate: disabledAfter(YESTERDAY_DATE) },
			previousSingleDate: { grid: { xs: 2 }, disabled: false, shouldDisableDate: disabledAfter(YESTERDAY_DATE) }
		}}
		onSubmit={() => {
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
    </Box>
}